export default __webpack_public_path__ + "static/media/twitter.fc5cc596.svg";